import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=03596408"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports